import { useLangContext } from "../providers/LangProvider/LangProviderContext.js";
import { useResponsive } from '../components/responsive';
import PageError from "../app/PageError.jsx";
import _ from "lodash";
import { LANG_CHOOSER_TYPES, LangChooser } from '../modules/LangChooser';
import { FooterLinksStyled } from "../modules/Welcome/common-sections/footer-section/styled/FooterSectionStyled.js";
import { LINKS } from "../app/appConstants.js";
import { FormGroup } from "react-bootstrap";
import { ContactsIconContainerStyled } from "./Contacts/styled/ContactsStyled.js";
import { BinIcon } from "../components/icon/Icon.jsx";

export const Promotions = () => {
    const {getLangPath} = useLangContext();
    const {isMediumMaxWidth, isSmallMaxWidth} = useResponsive();
    return (
            <PageError
                    iconComponent={
                        <ContactsIconContainerStyled className="mb-3">
                            <BinIcon name="IcCoinStack" style={{fontSize: '48px', fill: '#14C679'}}/>
                        </ContactsIconContainerStyled>
                    }
                    headerText={_.capitalize(getLangPath('footer.promotions'))}
                    headerPanelComponent={
                        <LangChooser
                                type={isMediumMaxWidth ? LANG_CHOOSER_TYPES.slider : LANG_CHOOSER_TYPES.dropdown}
                                isHideButtonArrowIcon={isMediumMaxWidth}
                                isHideButtonName={isSmallMaxWidth}
                        />
                    }
            >
                <div style={{textAlign: 'left'}}>
                    <FormGroup className="mb-2">
                        <FooterLinksStyled color={'white'} href={LINKS.promotionsDoc} target="__blank">
                            <BinIcon name={'IcDocument'} style={{fill: 'white'}}/> {getLangPath('bonus.welcome.title')}
                        </FooterLinksStyled>
                    </FormGroup>
                    <FormGroup className="mb-2">
                        <FooterLinksStyled color={'white'} href={LINKS.rulesNewLifeDoc} target="__blank">
                            <BinIcon name={'IcDocument'}
                                     style={{fill: 'white'}}/> {getLangPath('bonus.new_life.respawn_title')}
                        </FooterLinksStyled>
                    </FormGroup>
                </div>
                <FormGroup className="mt-4">
                    {getLangPath('forms.label.email')}:{' '}
                    <a href="mailto:support@fx.binomo.com" style={{color: 'var(--color-white)'}}>
                        support@fx.binomo.com
                    </a>
                </FormGroup>
            </PageError>
    )
}
